import instance from "../utils/network";
import { CurrentReservationResponse } from "./reservation";
import { PaymentMethod } from "./settlement";

export enum MemberMileageLogType {
  CASH = "CASH",
  BANK = "BANK",
  CARD = "CARD",
  BUY = "BUY",
  CASH_CANCEL = "CASH_CANCEL",
  BANK_CANCEL = "BANK_CANCEL",
  CARD_CANCEL = "CARD_CANCEL",
  BUY_CANCEL = "BUY_CANCEL",
  MANUAL_CHARGE = "MANUAL_CHARGE",
  MANUAL_CHARGE_CANCEL = "MANUAL_CHARGE_CANCEL",
  EXPIRES = "EXPIRES",
}
export interface PubMemberDto {
  memberId: number;
  nickname: string;
  phoneNumber: string;
  point: number;
  seed: number;
  isAdult: boolean;
  isSitIn?: boolean;
  name: string;
  birthDay: string;
  userId: number;
  memo?: string;
}
export interface GetPubMemberListResponse {
  memberList: PubMemberDto[];
}
export interface MemberResponse {
  nickname: string;
  phoneNumber: string;
  alreadyMember: boolean;
  isPubMember: boolean;
}

export interface UserMemberResponse {
  nickname: string;
  memberId: number;
  isAdult: boolean;
  isSitIn?: boolean;
}

export interface JoinMemberRequest {
  nickname: string;
  phoneNumber: string;
  pubId: number;
}

export interface memberSurveyResponse {
  createdAt: Date;
  nickname: string;
  route: string;
  area?: string;
  gender: number;
  age: string;
  experience: number;
  usedPub: boolean;
}

export interface SellerMemberDto {
  createdAt: string;
  id: number;
  point: number;
  seed: number;
  carrot?: number; // 보유 캐럿(CR)
  mileage: number;
  count?: number; //참가 횟수
  deletedAt?: string;
  birthDay?: string;
  nickname: string;
  isAdult: boolean;
  userId: number;
  memo: string;
}

export interface SellerMemberResponse {
  list: SellerMemberDto[];
  total: number;
}

export interface DailySellerMemberResponse {
  day: string;
  registerCount: number;
  visitCount: number;
}

export interface MainDashboardResponse {
  daily: DailySellerMemberResponse[];
  weeklyCount: number;
  monthlyCount: number;
}
export interface SellerMemberDashboardResponse {
  dailySellerMemberList: DailySellerMemberResponse[];
  memberList: SellerMemberDto[];
}

export interface MileageMemberRequest {
  memberId: number;
  pubId: number;
  amount: number;
}
export interface MileageMemberHistoryResponse {
  date: string;
  type: string;
  point: number;
  menu?: string;
  id: number;
  memberPurchaseId: number;
  isWithdraw: boolean;
}

export interface MemberMileageAllLogResponse {
  date: Date;
  type: MemberMileageLogType;
  menu: string;
  point: number;
  memberPurchaseId: number;
  id: number;
  isWithdraw: boolean;
  nickname: string;
  pubName: string;
}

export interface MemberMileageLogListResponse {
  list: MemberMileageAllLogResponse[];
  total: number;
}

export interface QrMemberResponse {
  isMember: boolean;
  phoneNumber: string;
  username: string;
  nickname: string;
  isParticipant: boolean;
  isReservation: boolean;
  member?: SellerMemberDto;
  currentReservation?: CurrentReservationResponse;
}

export interface MemberDepositLogResponse {
  point: number;
  list: MemberDepositLogDto[];
}

export enum DepositLogType {
  PAYMENT = "PAYMENT", // 결제
  PAYMENT_CANCEL = "PAYMENT_CANCEL", // 결제 취소
}

export interface DepositPayment {
  amount: number;
  paymentMethod: PaymentMethod;
}
export interface MemberDepositLogDto {
  id: number;
  memberId: number;
  pubId: number;
  type: DepositLogType;
  totalPoint: number;
  depositPoint: number;
  promotionPoint: number;
  paymentAmount: number;
  isRefund: boolean;
  paymentMethods: DepositPayment[];
  revenueIds: number[];
  createdAt: string;
}

export function getPubMember(
  nickname: string,
  pubId: number,
): Promise<PubMemberDto> {
  return instance.get(`/seller/member/${nickname}/${pubId}`);
}

export function getPubMemberList(
  nickname: string,
  pubId: number,
): Promise<GetPubMemberListResponse> {
  return instance.get(`/seller/member/list/${nickname}/${pubId}`);
}

export function getSearchTournamentMember(
  nickname: string,
  pubId: number,
  tournamentId: number,
): Promise<GetPubMemberListResponse> {
  return instance.get(
    `/seller/member/join-list/${nickname}/${pubId}?tournamentId=${tournamentId}`,
  );
}
export function getTournamentMember(
  tournamentId: number,
): Promise<GetPubMemberListResponse> {
  return instance.get(
    `/seller/member/join-list?tournamentId=${tournamentId}&isSitOut=false`,
  );
}

export function getMemberSearch(
  nickname: string,
  phone: string,
  pubId: number,
): Promise<{ code: number; message: any; payload: MemberResponse }> {
  return instance.get(
    `/seller/member/find-user?nickname=${nickname}&phoneNumber=${phone}&pubId=${pubId}`,
  );
}

export function getUserSearchByNickname(
  nickname: string,
  pubId: number,
): Promise<{ code: number; message: any; payload: MemberResponse }> {
  return instance.get(
    `/seller/member/find/nickname?nickname=${nickname}&pubId=${pubId}`,
  );
}

export function getUserAndMemberByNickname(
  nickname: string,
  pubId: number,
): Promise<{ code: number; message: any; payload: UserMemberResponse[] }> {
  return instance.get(
    `/seller/member/find/user-member?nickname=${nickname}&pubId=${pubId}`,
  );
}

export function joinMemberApi(
  req: JoinMemberRequest,
): Promise<{ code: number; message: any }> {
  return instance.post(`/seller/member`, req);
}

export function addRandomMember(pubId: number): Promise<any> {
  return instance.get(`/seller/member/addRandomMember/${pubId}`);
}

export function getMemberDashboard(
  pubId: number,
  filterType: string,
): Promise<DailySellerMemberResponse[]> {
  return instance.get(`/seller/member/dashboard/${pubId}?type=${filterType}`);
}

export function getMemberMainDashboard(
  pubId: number,
): Promise<MainDashboardResponse> {
  return instance.get(`/seller/member/main/dashboard/${pubId}`);
}

export function getMemberDashboardListSort(
  page: number,
  limit: number,
  pubId: number,
  search: string,
  sort?: string,
  order?: string,
  year?: string | null,
  month?: string | null,
): Promise<SellerMemberResponse> {
  if (sort) {
    return instance.get(
      `/seller/member/dashboard-list?sort=${sort}&order=${order}&limit=${limit}&page=${page}&search=${search}&year=${year}&month=${month}&pubId=${pubId}`,
    );
  }
  return instance.get(
    `/seller/member/dashboard-list?limit=${limit}&page=${page}&search=${search}&pubId=${pubId}`,
  );
}

export function getMemberSurveyList(
  pubId: number,
  year: string,
  month: string,
): Promise<memberSurveyResponse[]> {
  return instance.get(
    `/seller/member/survey?pubId=${pubId}&year=${year}&month=${month}`,
  );
}

export function getMileageMember(
  nickname: string,
  pubId: number,
): Promise<GetPubMemberListResponse> {
  return instance.get(`/seller/member/mileage/list/${nickname}/${pubId}`);
}

export function chargeMileageMember(data: MileageMemberRequest): Promise<any> {
  return instance.post(`/seller/member/mileage/charge`, data);
}

export function chargeCancelMileageMember(id: number): Promise<any> {
  return instance.delete(`/seller/member/mileage/charge/${id}`);
}

export function getMileageMemberHistory(
  memberId: number,
): Promise<MileageMemberHistoryResponse[]> {
  return instance.get(`/seller/member/mileage/log/${memberId}`);
}

export function getMileageAllMemberLogs(
  pubId: number,
  date: string,
  type: string,
  page: number,
  limit: number,
  search: string,
  productId: number | null,
): Promise<{
  code: number;
  message: string;
  payload: MemberMileageLogListResponse;
}> {
  return instance.get(`/seller/member/mileage/all/log`, {
    params: { pubId, date, type, page, limit, search, productId },
  });
}

export function getQrMember(
  userId: number,
  pubId: number,
  tournamentId: number,
): Promise<QrMemberResponse> {
  return instance.get(
    `/seller/member/qr?userId=${userId}&pubId=${pubId}&tournamentId=${tournamentId}`,
  );
}

export function getMemberDepositLog(
  memberId: number,
): Promise<MemberDepositLogResponse> {
  return instance.get(`/seller/member/deposit/${memberId}`);
}

export function updateMemberMemo(memberId: number, memo: string): Promise<any> {
  return instance.put(`/seller/member/memo`, { memberId, memo });
}
